'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';

// Error que tumba la pagina entera (fuera de cualquier ErrorBoundary): se manda a Sentry y se ofrece
// recargar. Sin este fichero Next mostraba su pantalla por defecto y no quedaba rastro.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="es">
      <body style={{ fontFamily: 'sans-serif', padding: 32 }}>
        <h2>Ha ocurrido un error</h2>
        <p>Ya nos ha llegado el aviso. Puedes intentarlo de nuevo.</p>
        <button onClick={() => reset()}>Reintentar</button>
      </body>
    </html>
  );
}
